import { render } from "./ErrorModal.vue?vue&type=template&id=573d35c7&ts=true"
import script from "./ErrorModal.vue?vue&type=script&lang=ts"
export * from "./ErrorModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__